module.exports = __webpack_public_path__ + "static/media/6.2 Blumenstillleben UV Firnis klein.47536c8f.jpg";